import { FormStore } from '@roc/feature-app-core';
import { createCurrencyField } from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const AnnualInsurance = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Annual Insurance",
        fieldName: 'totalGrossAnnualInsurance',
        testId: 'totalGrossAnnualInsurance',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});